import { createAction, props } from "@ngrx/store";
import { IComparator } from "../models/comparator.models";
import { IExecuteSeccess, IMatchingColumn, IMatchingErrorsResponse, IResponseMatching, IRowsErrorsResponse } from "../../imports/models/imports.models";
import { APIResponse } from "src/app/core/models/api-response";


// get Comparators
export const GetComparators = createAction(
    '[ Comparator ] - GetComparators',
  );
  export const GetComparatorsSuccess = createAction(
    '[ Comparator ] - GetComparators Success ',
    props<{ Comparators: APIResponse<IComparator> }>()
  );
  export const GetComparatorsError = createAction(
    '[ Comparator ] - GetComparators Error',
  );

export const SetComparatorLoader = createAction(
    '[ Comparator ] - SetComparatorLoader',
    props<{ isLoading: boolean }>()
  );
export const SetExecuteComparatorsLoader = createAction(
  '[ Comparator ] - SetExecuteImportComparatorsLoader',
  props<{ isLoading: boolean }>()
)

// set file
export const ImportComparators = createAction(
  '[ import ] - ImportComparators',
  props<{ file: any, reimport: boolean }>()
);
export const ImportComparatorsSuccess = createAction(
  '[ import ] - ImportComparators Success ',
  props<{ responseMatching: IResponseMatching, reimport: boolean }>()
);
export const ImportComparatorsError = createAction(
  '[ import ] - ImportComparators Error',
);


  // reset file
  export const ReImportComparators = createAction(
    '[ import ] - ReImportComparators',
    props<{ id: number, file: any }>()
  );
  export const ReImportComparatorsSuccess = createAction(
    '[ import ] - ReImportComparators Success ',
    props<{ responseMatching: IResponseMatching }>()
  );
  export const ReImportComparatorsError = createAction(
    '[ import ] - ReImportComparators Error',
  );


  // matching columns
  export const MatchingComparatorsColumns = createAction(
    '[ import ] - MatchingComparatorsColumns',
    props<{ id: number, matchingColumns: IMatchingColumn, committed?: boolean }>()
  );
  export const MatchingComparatorsColumnsSuccess = createAction(
    '[ import ] - MatchingComparatorsColumns Success ',
    props<{ executeSeccess: IExecuteSeccess, test: boolean }>()
  );
  export const MatchingComparatorsColumnsError = createAction(
    '[ import ] - MatchingComparatorsColumns Error',
    props<{ responseMatching: IMatchingErrorsResponse | IRowsErrorsResponse }>()
  );

  // get comparator
  export const DetailsComparator = createAction(
    '[ import ] - DetailsComparator',
    props<{ id: number }>()
  );
  export const DetailsComparatorSuccess = createAction(
    '[ import ] - DetailsComparator Success ',
    props<{ deatailsComparator: IExecuteSeccess }>()

  );
  export const DetailsComparatorError = createAction(
    '[ import ] - DetailsComparator Error',
  );

  // clear details
  export const ClearDetailsComparator = createAction(
    '[ import ] - ClearDetailsComparator',
  );





